import lodashCloneDeep from "lodash/cloneDeep";
import lodashFind from "lodash/find";

import { httpGet } from "@/services/api.service";

import { ENDPOINT_METHODOLOGY_CONFIG } from "@/common/constants/api";

export { _getMethodology as getMethodology };
export { _getCityMethodology as getCityMethodology };

let methodologyConfig = {};

const _getMethodologyConfig = async (type) => {
  try {
    const url = `${ENDPOINT_METHODOLOGY_CONFIG}?type=${type}`;
    const result = await httpGet({ url });
    const { data } = JSON.parse(result);
    return data;
  } catch (error) {
    Promise.reject(
      "Issue getting methodology config in methodology.service.js: " +
        JSON.stringify(error)
    );
    return null;
  }
};

const _getMethodology = async (type) => {
  if (!type) {
    console.error("Methodology API: missing or invalid type - " + type);
    return null;
  }
  if (!methodologyConfig || !methodologyConfig[type]) {
    try {
      const methodology = await _getMethodologyConfig(type);
      if (!methodology) {
        throw "Error getting methodology config";
      }
      methodologyConfig[type] = _formatMethodology(methodology);
      return lodashCloneDeep(methodologyConfig[type]);
    } catch (error) {
      console.error("Methodology API: " + error);
      return null;
    }
  }
  return lodashCloneDeep(methodologyConfig[type]);
};

const _formatMethodology = (methodology) => {
  return methodology;
};

const _getCityMethodology = async () => {
  const methodology = await _getMethodology("methodology");
  return lodashFind(methodology, ["title", "City Methodology"]);
};
